import { render } from "./PointNavi.vue?vue&type=template&id=731ee022&scoped=true&ts=true"
import script from "./PointNavi.vue?vue&type=script&lang=ts"
export * from "./PointNavi.vue?vue&type=script&lang=ts"

import "./PointNavi.vue?vue&type=style&index=0&id=731ee022&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731ee022"]])

export default __exports__